import { WorkerForm } from '../types/worker';
import { PASSWORD_MIN_LENGTH } from '../constants/worker';

export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^[\+]?[0-9\s\-\(\)]{10,}$/;
  return phoneRegex.test(phone);
};

export const validatePassword = (password: string): string[] => {
  const errors: string[] = [];
  
  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push(`Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères`);
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Le mot de passe doit contenir au moins une minuscule');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Le mot de passe doit contenir au moins une majuscule');
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push('Le mot de passe doit contenir au moins un chiffre');
  }
  
  return errors;
};

export const validateStep = (step: number, form: WorkerForm): string | null => {
  switch (step) {
    case 0: // Personal Information
      if (!form.first_name.trim()) return 'Le prénom est requis';
      if (!form.last_name.trim()) return 'Le nom est requis';
      if (!form.email.trim()) return "L'email est requis";
      if (!validateEmail(form.email)) return "L'email n'est pas valide";
      if (!form.phone.trim()) return 'Le téléphone est requis';
      if (!validatePhone(form.phone)) return 'Le numéro de téléphone n\'est pas valide';
      if (!form.job.trim()) return 'Le poste recherché est requis';
      if (!form.contracts || form.contracts.length === 0) return 'Au moins un type de contrat est requis';
      if (!form.area) return 'La région est requise';
      if (!form.password) return 'Le mot de passe est requis';
      
      const passwordErrors = validatePassword(form.password);
      if (passwordErrors.length > 0) return passwordErrors[0];
      
      if (form.password !== form.confirm_password) {
        return 'Les mots de passe ne correspondent pas';
      }
      if (!form.terms_accepted) {
        return "Vous devez accepter les conditions d'utilisation";
      }
      break;
      
    case 1: // Qualifications
      if (!form.diploma.trim()) return 'Le diplôme est requis';
      if (!form.driver_license) return 'Le permis est requis';
      break;
      
    case 2: // Documents
      // CV is optional but if provided, validate it
      if (form.cv_classic) {
        // File validation will be done in the component
      }
      break;
  }
  return null;
};